/* Useful preset rules for validation */

import validator from 'validator';

import { getParsedPhoneNumber } from 'pages/checkout/utils/phoneUtils';

import { ValidationRuleDefinition } from './Validator';

export enum ValidationRulePresetName {
  email = 'email',
  password = 'password',
  phone = 'phone',
  phoneCountryCode = 'phoneCountryCode',
  required = 'required',
  insurance = 'insurance',
  isTrue = 'isTrue',
}

const phoneValidator = (value: string) => {
  const parsedPhoneNumber = getParsedPhoneNumber(value);
  return Boolean(parsedPhoneNumber?.isValid());
};

const phoneCountryCodeValidator = (value: string) => {
  const parsedPhoneNumber = getParsedPhoneNumber(value);

  if (!parsedPhoneNumber?.isValid()) {
    return false;
  }

  return parsedPhoneNumber.countryCallingCode === '1';
};

export const ValidationRulePreset: Record<ValidationRulePresetName, ValidationRuleDefinition> = {
  email: Object.freeze({
    validatorFunction: validator.isEmail,
    validWhen: true,
    message: 'Invalid email',
  }),
  password: Object.freeze({
    validatorFunction: validator.isLength,
    validWhen: true,
    args: [8, 100],
    message: 'Password must be at least 8 characters',
  }),
  phone: Object.freeze({
    customValidatorFunction: phoneValidator,
    validWhen: true,
    message: 'Invalid phone number',
  }),
  phoneCountryCode: Object.freeze({
    customValidatorFunction: phoneCountryCodeValidator,
    validWhen: true,
    message: 'Phone number must be from the United States or Canada',
  }),
  required: Object.freeze({
    validatorFunction: validator.isEmpty,
    validWhen: false,
    message: 'Required',
  }),
  isTrue: Object.freeze({
    customValidatorFunction: (value: boolean) => value,
    validWhen: true,
    message: 'Required',
  }),
  insurance: Object.freeze({
    customValidatorFunction: (value: { id: number; name: string; }) => {
      return Boolean(value?.id && value?.name);
    },
    validWhen: true,
    message: 'Required',
  }),
};
